import { CrossRegionPersistence } from "@brightagency/headstart-common";
import React, { useEffect, useState } from "react";
import { GlobalRegionMapping } from "../../../../constants/types";
import { useRegionsNewMappings } from "../../../../services/app-state";
import { useAssessmentState } from "../../../../services/assessment-state";
import { AssessmentState } from "../../../../services/assessment-state/types";
import { Location, SelectSuburbSearch } from "../SelectSuburbSearch";
import { AssessmentCopy } from "../utils";
import {
    Outer,
    SearchWrapper,
} from "./styled";

export const SelectSuburb: React.FC = () => {
    const { setState } = useAssessmentState();

    const [isRememberingLocation ] = useState(true);
    const [selectedLocation, setSelectedLocation] = useState<Location | undefined>();
    const regionsNewMapping = useRegionsNewMappings();
    const [, setShowNoMatchError] = useState(false);
    const [matchingRegion, setMatchingRegion] = useState<GlobalRegionMapping | undefined>();
    
    useEffect(() => {

        if (!selectedLocation) {
            return;
        }

        const matchingRegion = regionsNewMapping?.find((r: { postcodes: string; }) => {
            const postcodes = r.postcodes.split(",").map((p: string) => parseInt(p, 10));
            return postcodes.includes(selectedLocation?.postcode ?? -1);
        });

        setMatchingRegion(matchingRegion);

        if (matchingRegion) {
            setShowNoMatchError(false);
        } else {
            setShowNoMatchError(true);
        }

        if (!selectedLocation || !matchingRegion) return;

        CrossRegionPersistence.setChosenSuburb({
            ...selectedLocation,
            // regionUrl: matchingRegion.url,
            regionUrl: '/',
            regionname: matchingRegion.name,
            regionblurb: matchingRegion.region_blurb,
            region_logo: matchingRegion.region_logo.url,
            notification_bar_enabled: matchingRegion.notification_bar.enabled,
            notification_bar_content: matchingRegion.notification_bar.content,
            remembered: isRememberingLocation,
        });

    }, [isRememberingLocation, matchingRegion, regionsNewMapping, selectedLocation, setState]);

    return (
        <>
            <p>{AssessmentCopy.SELECT_SUBURB}</p>
            <Outer>
                <SearchWrapper>
                    <SelectSuburbSearch onLocationSelect={setSelectedLocation} />
                </SearchWrapper>            
            </Outer>
        </>
    );

};

export default {
    Component: SelectSuburb,
    createMeta: (state: AssessmentState) => ({
        title: "Before you begin",
        canProgress: state.suburb !== "",
        canSkip: false,
    }),
};